import Vue from 'vue'
 
// 向外共享 Vue 的实例对象
export default new Vue()
